/**
 * web sdk to play video, support mp4 type only
 * see https://cloud.tencent.com/document/product/454/7479
 *
 * @param {String} id
 * @param {String} url
 */
function playVideo(id, url, cover) {
  window[id] = new window.TcPlayer(id, {
    mp4: url,
    width: '100%',
    height: '200',
    coverpic: cover || '',
  })
}

export default playVideo



// WEBPACK FOOTER //
// ./client/utils/video-play.js